import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

export type PurchaseRequestT = {
  id: string;
  errorCallback?: Function;
  successCallback?: Function;
  resultKey?: string;
};

export default ({
  id,
  errorCallback = () => {},
  successCallback = () => {},
  resultKey = 'purchaseRequestData',
}: PurchaseRequestT) =>
  requestAsync({
    url: endpoints.getPurchaseRequestUrl(id),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getPurchaseRequestUrl(id),
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
      successCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
